import { useMemo } from 'react';
import { userPermittedPolicyTypes } from '../../../../../shared/permissions';
import { Action } from '../../../../../typings/permissions';
import { window } from '../../../../globals';
import type { PolicyType } from '../../../../types';

/**
 * Checks the user's permissions and returns the policy types that
 * the user is permitted to perform the specified action.
 */
export default function useUserPermittedPolicyTypes(): PolicyType[] {
  return useMemo(() => userPermittedPolicyTypes(window.user?.permissions ?? [], Action.View), []);
}
